import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "./images/logo-weiß.png";

// Navigation Links
const navLinks = [
  { to: "/home", label: "Home" },
  { to: "/aboutUs", label: "About Us" },
  { to: "/services", label: "Services" },
  { to: "/pricing", label: "Pricing" },
  { to: "/contact", label: "Contact" },
];

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to toggle menu visibility

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev); // Toggle the menu state
  };

  return (
    <header className="fixed top-0 left-0 w-full z-20 bg-gray-900 bg-opacity-80 backdrop-blur-md">
      <nav className="max-w-7xl mx-auto px-6 flex items-center justify-between py-3">
        {/* Logo */}
        <Link to="/home">
          <img src={logo} alt="Logo" className="w-40 opacity-90" />
        </Link>

        {/* Desktop Navigation Links */}
        <ul className="hidden md:flex space-x-6">
          {navLinks.map(({ to, label }) => (
            <li key={to}>
              <Link to={to} className="text-gray-300 hover:text-white transition">
                {label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Hamburger Menu Icon (visible on mobile) */}
        <button
          onClick={toggleMenu}
          className="md:hidden text-white focus:outline-none"
        >
          {isMenuOpen ? (
            <svg
              className="w-8 h-8"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          ) : (
            <svg
              className="w-8 h-8"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          )}
        </button>
      </nav>

      {/* Mobile Navigation Links (hidden by default) */}
      <div
        className={`md:hidden ${isMenuOpen ? "block" : "hidden"} bg-gray-900 bg-opacity-80 backdrop-blur-md absolute w-full left-0 top-16 py-4`}
      >
        <ul className="flex flex-col items-center space-y-4">
          {navLinks.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                className="text-gray-300 hover:text-white transition"
                onClick={() => setIsMenuOpen(false)} // Close menu after click
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
};

export default Header;
